import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';
import { onShowModalAddProduct, downloadProductsReport } from '../../data/product/actions';
import { onClickSidebarMenu } from '../../data/actions/sidebar';
import { showModalAddNewMaintenancePlan } from '../../data/maintenanceType/action';
import { onShowModalAddProductModel } from '../../data/productModels/action';
import { onShowModalAddProductAddon } from '../../data/productAddons/actions';
import { pushDangerNotification } from '../../data/notifications/actions';
import Sidebar from '../../components/Sidebar';
import { useScrollShadows } from '../../hooks/useScrollShadows';
import Preloader from '../../components/preloader';

const MaintenanceServicesMaster = (props) => {
	const [loading, setLoading] = useState(true);
	const navigate = useNavigate();
	const pageContentRef = useRef(null);

	useScrollShadows(pageContentRef);
	const { loadUserData, userRole, onShowModalAddProduct, onShowModalAddProductModel, onShowModalAddProductAddon, showModalAddNewMaintenancePlan, onClickSidebarMenu } = props;

	const navigateToNewProduct = () => {
		navigate('new-product');
	};

	const downloadExcel = () => {
		downloadProductsReport()
			.then()
			.catch((error) => {
				pushDangerNotification(`Could not download operations products excel report. Reason: ${error.message}`);
			});
	};

	const MAINTENANCE_ROUTES = {
		PRODUCTS: {
			LABEL: 'Products',
			PATH: 'maintenance-plans',
			IDENTIFIER: 'products',
			ITEMS: [
				{
					menuTitle: 'Add product',
					fnToExecute: navigateToNewProduct,
				},
				{
					menuTitle: 'Download products report',
					fnToExecute: downloadExcel,
				},
			],
		},
		PRODUCT_MODELS: {
			LABEL: 'Product Models',
			PATH: 'hyper-models',
			IDENTIFIER: 'models',
			ITEMS: [
				{
					menuTitle: 'Add model',
					fnToExecute: onShowModalAddProductModel,
				},
			],
		},
		PRODUCT_FEATURES: {
			LABEL: 'Product Licenses',
			PATH: 'product-addons',
			IDENTIFIER: 'product-addons',
			ITEMS: [{
				menuTitle: 'Add new license',
				fnToExecute: onShowModalAddProductAddon
			}]
		},
		EDITIONS: {
			LABEL: 'Editions',
			PATH: 'editions',
			IDENTIFIER: 'editions',
			ITEMS: [],
		},
		COMPANIES: {
			LABEL: 'Companies',
			PATH: 'companies',
			IDENTIFIER: 'companies',
			ITEMS: [],
		},
		MAINTENANCE_TYPES: {
			LABEL: 'Maintenance Types',
			PATH: 'maintenance-types',
			IDENTIFIER: 'maintenanceTypes',
			ITEMS: [
				{
					menuTitle: 'Add maintenance type',
					fnToExecute: showModalAddNewMaintenancePlan,
				},
			],
		},
	};

	const MAINTENANCE_SECTIONS = [
		{
			LABEL: 'Fleet',
			ICON: 'fa-server',
			ITEMS: [MAINTENANCE_ROUTES.PRODUCTS, MAINTENANCE_ROUTES.COMPANIES]
		},
		{
			LABEL: 'Catalogue',
			ICON: 'fa-book-open',
			ITEMS: [MAINTENANCE_ROUTES.PRODUCT_MODELS, MAINTENANCE_ROUTES.PRODUCT_FEATURES, MAINTENANCE_ROUTES.EDITIONS, MAINTENANCE_ROUTES.MAINTENANCE_TYPES]
		}
	];

	useEffect(() => {
		switch (location.pathname.split('/')[2]) {
			case MAINTENANCE_ROUTES.PRODUCT_MODELS.PATH:
				onClickSidebarMenu(MAINTENANCE_ROUTES.PRODUCT_MODELS.IDENTIFIER);
				break;
			case MAINTENANCE_ROUTES.PRODUCT_FEATURES.PATH:
				onClickSidebarMenu(MAINTENANCE_ROUTES.PRODUCT_FEATURES.IDENTIFIER);
				break;
			case MAINTENANCE_ROUTES.EDITIONS.PATH:
				onClickSidebarMenu(MAINTENANCE_ROUTES.EDITIONS.IDENTIFIER);
				break;
			case MAINTENANCE_ROUTES.COMPANIES.PATH:
				onClickSidebarMenu(MAINTENANCE_ROUTES.COMPANIES.IDENTIFIER);
				break;
			case MAINTENANCE_ROUTES.MAINTENANCE_TYPES.PATH:
				onClickSidebarMenu(MAINTENANCE_ROUTES.MAINTENANCE_TYPES.IDENTIFIER);
				break;
			case MAINTENANCE_ROUTES.PRODUCTS.PATH:
			default:
				onClickSidebarMenu(MAINTENANCE_ROUTES.PRODUCTS.IDENTIFIER);
				break;
		}
	}, []);

	useEffect(() => {
		if (userRole && userRole !== 'operations') {
			navigate('/');
		}

		if (!loadUserData && userRole) {
			setLoading(false);
		}
	}, [loadUserData, userRole]);

	return (
		<div id="maintenance-services" className="w-100 mt-4">
			<div className="container-fluid">
				<div className="row">
					<div className="side-menu">
						<Sidebar sections={MAINTENANCE_SECTIONS} />
					</div>

					<div className="page-content row" ref={pageContentRef}>{!loading ? <Outlet /> : <Preloader dataIsLoading={loading} />}</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		loadUserData: state?.user?.loading,
		userRole: state?.user?.user?.account?.role
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onShowModalAddProduct: () => { return dispatch(onShowModalAddProduct()); },
		onShowModalAddProductModel: () => { return dispatch(onShowModalAddProductModel()); },
		onShowModalAddProductAddon: () => { return dispatch(onShowModalAddProductAddon()); },
		showModalAddNewMaintenancePlan: () => { return dispatch(showModalAddNewMaintenancePlan()); },
		onClickSidebarMenu: (path) => { dispatch(onClickSidebarMenu(path)); }
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(MaintenanceServicesMaster);
